import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-88086d78"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["data-tex-formula"]
const _hoisted_2 = ["data-tex-formula"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (!_ctx.inline)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "formula-container",
        ref: "container",
        "data-tex-formula": _ctx.formula
      }, null, 8, _hoisted_1))
    : (_openBlock(), _createElementBlock("span", {
        key: 1,
        class: "formula-container",
        ref: "container",
        "data-tex-formula": _ctx.formula
      }, null, 8, _hoisted_2))
}